module.exports = __webpack_public_path__ + "static/img/banner5.ec74b75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner5.png
// module id = N81b
// module chunks = 12